// Horizontal product row: --prev / --next commands scroll the track by most of one viewport width, mirrored for RTL.
class ScrollRow extends HTMLElement {
  #controller = null;

  connectedCallback() {
    this.#controller = new AbortController();
    this.addEventListener('command', (event) => this.#onCommand(event), { signal: this.#controller.signal });
  }

  disconnectedCallback() {
    this.#controller?.abort();
  }

  #onCommand(event) {
    if (event.command !== '--next' && event.command !== '--prev') return;
    const track = this.querySelector('[data-scroll-track]');
    if (!track) return;
    const isRtl = getComputedStyle(this).direction === 'rtl';
    const forward = event.command === '--next' ? 1 : -1;
    const step = track.clientWidth * 0.8 * forward * (isRtl ? -1 : 1);
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    track.scrollBy({ left: step, behavior: reduce ? 'auto' : 'smooth' });
  }
}

if (!customElements.get('s-scroll-row')) customElements.define('s-scroll-row', ScrollRow);
